export const state = () => ({
    frontScriptLoaded: false,
    frontChatInit: false,
});

export const mutations = {
    setScriptLoaded(state, loaded) {
        state.frontScriptLoaded = loaded;
    },
    setInitFinished(state, loaded) {
        state.frontChatInit = loaded;
    },
};

export const actions = {
    setFrontScriptLoadedTrue({ commit }) {
        commit('setScriptLoaded', true);
    },
    setFrontInitCompleted({ commit }) {
        commit('setInitFinished', true);
    },
};

export const getters = {
    frontScriptLoaded(state) {
        return state.frontScriptLoaded;
    },
    chatInitFinished(state) {
        return state.frontChatInit;
    },
};
